import React, {Component} from "react";
import {connect} from "react-redux";
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import downGreenChevron from "../../images/down-green-chevron.png";
import {fetchGreaterRegions, changeValue, setVal} from "../../actions";
import {Button, ButtonGroup} from 'reactstrap';


export class GreaterRegions extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.state = {
            dropdownOpen: false,
            currentIndex: 0
        }
        
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }
    onClick(e) {
        const { selectedWheelPosition, updateMarketPosition,
            setVal, myGreaterRegion, updateSVGDimensions, position,
            displayCities, sectorText, sectorColor } = this.props;
        updateMarketPosition('', 0);
        // we have to show the same wheel position and the corresponding definition
        setVal(selectedWheelPosition, selectedWheelPosition)

        const selectedRegion = e.target.getAttribute('data-region');
        myGreaterRegion(selectedRegion);
        if (updateSVGDimensions)
            updateSVGDimensions();
        if (position) {
            if (displayCities) {
                displayCities(sectorText, position, sectorColor);
            }
        }
    }

    render() {
        const styles = {
            marketLists: {
              width: 200
            },
            range: {
              marginLeft: 25,
              width: 275
            },
            svg: {
            whiteSpace:'pre'
            }
          }
    
      const greaterRegions = ['Global', 'Americas', 'Europe', 'Asia Pacific'];
        const { selectedRegion } = this.props;

        return(
            <div  className='greater-region-wrapper'  onClick={() => this.toggle()}>
              <Dropdown className='greater-region-toggle'  isOpen={this.state.dropdownOpen} toggle={() => this.toggle()}>
                    <DropdownToggle id={'greater-region-toggle-nav'} className='greater-region-toggle' >
                        {selectedRegion}
                    </DropdownToggle>
                    <DropdownMenu className='greater-region-menu'>
                        {greaterRegions.map((greaterRegion,idx) =>
                            <DropdownItem className='greater-region-menu-item' key={idx} data-region={greaterRegion} onClick={this.onClick}>{greaterRegion}</DropdownItem>
                        )}
                    </DropdownMenu>
                </Dropdown>
                <span className={`arrow-nav float-right arrowposition-greater-region`}><img src={downGreenChevron} alt="downArrow" height="10" width="15"/></span>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedRegion: state.greaterRegions,
        selectedWheelPosition: state.selectedWheelPosition.selectedWheelPosition
    };
};

const mapDispatchToProps = (dispatch) => {

    return {
        myGreaterRegion: (greaterRegion) => {
            dispatch(fetchGreaterRegions(greaterRegion));
        },
        updateMarketPosition: (marketid, positionid) => {
            dispatch(changeValue(marketid, positionid))
        },
        setVal: (selectedDefinition, selectedWheelPosition) => {
            dispatch(setVal(selectedDefinition, selectedWheelPosition))
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GreaterRegions);
